import { SyncEntity } from "../src/entity/Sync";
import { Constants } from "./constants";
import { SyncDirection } from "./sesh_types";

export namespace sync_utils {
	export function isSyncLimitReached(
		syncs: SyncEntity[],
		sync_direction: SyncDirection,
		is_premium: boolean
	) {
		if (sync_direction === SyncDirection.Bidirectional) {
			return (
				isSyncLimitReached(syncs, SyncDirection.Inbound, is_premium) ||
				isSyncLimitReached(syncs, SyncDirection.Outbound, is_premium)
			);
		}

		const amount = syncs.filter(
			(val) => val.sync_direction === sync_direction
		).length;

		return (
			amount >=
			Constants.SYNC_LIMITS[sync_direction][
				is_premium ? "premium" : "standard"
			]
		);
	}
}
